:host {
  @include cms-components-host-defaults;
  width: 100%;
  margin: 0;
}

.container {
  padding: var(--cms-grid-padding);
  box-sizing: inherit;
  max-width: calc(var(--cms-container-max-width) - var(--cms-spacing-200));
  margin: 0 auto;
}

.inner {
  position: relative;
}

.item {  
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  font-family: var(--cms-brandfont2);
  font-weight: var(--cms-base-font-weight);
  box-sizing: border-box;
  color: var(--cms-theme-text-color);
  font-size: var(--cms-font-size-100);
  line-height: var(--cms-line-height-125);
  padding: var(--cms-spacing-025) 0;
  display: none;
}

.item:nth-child(1) cms-link {
  margin-left: 0;
}

.text {
  white-space: nowrap;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: inline-block;
  margin: 0.25rem;
}

cms-icon {
  vertical-align: middle;
  margin: 0 var(--cms-spacing-012);
  user-select: none;
  fill: currentColor;
  flex-shrink: 0;
  display: inline-block;
}

.list {
  display: flex;
  border-radius: var(--cms-border-radius-025);
  margin: 0;
  list-style: none;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  white-space: nowrap;
  scroll-snap-align: start;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.item:nth-last-child(-n + 2) {
  display: inline-block;
}

.item:nth-last-child(2)::before {
  display: none;
}

.item:last-child::before {
  font-weight: var(--cms-base-font-weight);
}

@include media-width($breakpoint-sm) {

  .item {
    display: block;
  }

  .item + .item::before {
    display: inline-block;
  }
}